/**
 * Created by Ning Jiang on 6/28/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineLite} from "gsap";
import {FruitsGameModuleConfig} from "../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode, IFruitsGameModeChangedData} from "../../gamemode/FruitsGameMode";
import {FruitsStickyRespinReelStopPresentation} from "../../reelstoppresentation/stickyrespin/FruitsStickyRespinReelStopPresentation";
import {FruitsReelSymbol} from "../../reelsymbol/FruitsReelSymbol";
import {PreOutroScreenView} from "../../screen/bonusgame/bits/PreOutroScreenView";
import {BonusGameIntroView} from "../../screen/bonusgame/intro/BonusGameIntroView";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "../../server/data/FruitsParsedInitData";
import {FruitsReelController} from "../reel/FruitsReelController";
import {FruitsReelAreaView} from "./FruitsReelAreaView";

export class FruitsReels extends Reels {

    public static nearWinReels:boolean[] = [];
    public static nearWinPositions:boolean[][];
    public static bigWinExcitementPositions:boolean[][];

    private readonly _orderLand:number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    private readonly _orderPort:number[] = [1, 0, 3, 2, 6, 5, 4, 9, 8, 7, 12, 11, 10, 15, 14, 13];

    private readonly _orderBonusLand:number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    private readonly _orderBonusPort:number[] = [2, 1, 0, 5, 4, 3, 8, 7, 6, 11, 10, 9, 13, 12, 15, 14];

    private _fruitsView:FruitsReelAreaView;
    private _gameMode:string;
    private _gameData:FruitsParsedGameData;
    private _orientation:Orientation;

    private _isStickyMode:boolean;
    private _isChangeModeQueued:boolean = false;

    public static readonly SET_ORIENTATION:string = "fruitsReelAreaController_setOrientation";
    public static readonly SET_FAKE_REELSET:string = "fruitsReelAreaController_setFakeReelset";
    private _onChangeModeTimeline:TimelineLite | null;
    private _onChangeModeData:IFruitsGameModeChangedData;
    private _activeOrder:number[];
    private _overlayStickySymbolsBeforeSpin:boolean[];

    constructor() {
        super();

        this._fruitsView = <FruitsReelAreaView>Reels._reelAreaView;
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onChangeMode(event.params[0]));
        EventHandler.addEventListener(this, PreOutroScreenView.ABORT_OUTRO_COUNT_UP, () => this.abortOutroCountUp());
        EventHandler.addEventListener(this, FruitsReels.SET_ORIENTATION, (event:GameEvent) => this.onOrientationChange(event.params[0]));
    }

    private onInitDataParsed(data:FruitsParsedInitData):void {
        this._isChangeModeQueued = false;
    }

    protected onGameDataParsed(data:FruitsParsedGameData):void {
        this._isStickyMode = data.mode === FruitsGameMode.STICKY_RESPIN;
        this._overlayStickySymbolsBeforeSpin = data.overlayStickySymbolsBeforeSpin;
        this._isChangeModeQueued = false;
        this._gameData = data;
        this.onOrientationChange(this._orientation);

        FruitsReels.nearWinReels = [];

        let i:number = 0;
        FruitsReels.nearWinPositions!.forEach((reel) => {
            reel.forEach((sym) => {
                if(i !== 0 && i !== 3)
                    FruitsReels.nearWinReels!.push(sym);
                i++;
            });
        });

        let newArr:boolean[] = [];
        let isBigWinExcitement:boolean = false;
        for(let i:number = 0; i < 6; i++) {
            newArr = newArr.concat(FruitsReels.bigWinExcitementPositions[i])
        }

        newArr.splice(0, 1);
        newArr.splice(3, 1);

        for(let i:number = 0; i < 16; i++) {
            if(newArr[i]) {
                isBigWinExcitement = true;
                break;
            }
        }

        if(isBigWinExcitement)
            FruitsReels.nearWinReels = newArr;

        if(this._gameData!.mode === FruitsGameMode.STICKY_RESPIN)
            SlotGame.sound.playEffect(FruitsSoundConfig.BONUS_SWEEP_2);
    }

    private flattenOverlay(input:boolean[][]):boolean[] {
        let result:boolean[] = [];
        input.forEach((reel:boolean[], reelId:number) => {
            if(reelId < 2) {
                result = result.concat(reel.slice(1))
            } else {
                result = result.concat(reel);
            }
        });
        return result;
    }

    private parseLastReel(stickyBeforeSpin:boolean[]):number {
        for(let i = 15; i > -1; i--) {
            if(!stickyBeforeSpin[i]) {
                return i;
            }
        }
        return 0;
    }


    // TODO: the next reel set trick doesn't work. there are B1 and B2 in the big plate in reels.

    private onChangeMode(data:IFruitsGameModeChangedData):void {
        this._onChangeModeData = data;
        this._gameMode = data.newMode === FruitsGameMode.BONUS_GAME ? data.newMode : FruitsGameMode.NORMAL;
        this._fruitsView.changeGameMode(this._gameMode);

        if(data.animate == null) {
            return;
        }

        this._onChangeModeTimeline = new TimelineLite();
        this._onChangeModeTimeline.add(this._fruitsView.getViewPresentation(data.newMode, data.animate, data.showIntro, data.isRestoreAndTriggered));

        if(data.showIntro) {
            this._onChangeModeTimeline.add(() => EventHandler.dispatchEvent(new GameEvent(BonusGameIntroView.START_BONUS_INTRO_PRES)));
        }

        if(!this._isChangeModeQueued) {
            this._isChangeModeQueued = true;
            this._onChangeModeTimeline.add(this.endChangeMode());
        }
    }

    private abortOutroCountUp():void {
        if(this._onChangeModeTimeline) {
            if(this._onChangeModeTimeline.isActive()) {
                this._onChangeModeTimeline.pause();
                this._onChangeModeTimeline.kill();
                this._onChangeModeTimeline.clear();
            }
            this._onChangeModeTimeline = null;
        }
        this._onChangeModeTimeline = new TimelineLite();
        this._onChangeModeTimeline.add(this._fruitsView.abortedOutroAnimation());
        this._onChangeModeTimeline.add(this.endChangeMode());
    }

    private endChangeMode():TimelineLite {
        const movingReelsNum:number = this._onChangeModeData.newMode === FruitsGameMode.BONUS_GAME ? 4 : 12;
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            // update bonus reels id, nextReelSet, TODO: symbols and so on.
            for(let i:number = 0; i < movingReelsNum; i++) {
                Reels._reels.push(Reels._reels.shift()!);
            }
            (<FruitsReelController[]>Reels._reels).forEach((reel:FruitsReelController, newReelId:number) => {
                // NOTE: I didn't change the ReelViews order in ReelAreaView so we can still use the same reel positions in the config
                // If we add any function on ReelView other than resizing, we need to fix the positioning for bonus game.

                reel.changeReelId(newReelId);
                Reels._reels[newReelId] = reel;
                reel.changeAllReelSets();

                this.handleShitShow(newReelId);
            });
        });
        tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent(FruitsReelAreaView.GAME_MODE_SWITCHING_COMPLETED, this._onChangeModeData.newMode));
        });

        if(!this._onChangeModeData.animate) {
            tl.progress(1);
        }

        return tl;
    }

    private handleShitShow(reelId:number) {
        for(let i:number = 0; i < Reels.getReel(reelId)!.view.children.length; i++) {
            let sym:FruitsReelSymbol = <FruitsReelSymbol>Reels.getReel(reelId)!.view.children[i];
            if(sym && sym.symName != undefined) {
                sym.replaceWith("X", reelId);
            }
        }
    }

    private getInactiveReels() {
        this._overlayStickySymbolsBeforeSpin.forEach((element, index) => {
            if(element) {
                this._reelsSpinStates[index] = false;
            }
        });
    }

    protected onReelSpinStopped(reelId:number):void {
        this._reelsSpinStates[reelId] = false;

        if(this._isStickyMode) {
            this.getInactiveReels();
        }

        if(this._reelsSpinStates.indexOf(true) == -1) {
            Logger.logDev(`ReelAreaController.onReelSpinStopped():All reels stopped!`);
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STOPPED));
        }
    }

    private getLastActiveReelIndex():number {
        let lastIndex:number = 0;
        for(let i:number = 0; i < 16; i++) {
            if(!this._gameData!.overlayStickySymbolsBeforeSpin[i]) {
                lastIndex = this._activeOrder[i];
            }

        }
        return lastIndex;
    }

    private checkRespinEnded():boolean {
        return this._gameData.nextMode === FruitsGameMode.NORMAL || this._gameData.mode === FruitsGameMode.STICKY_RESPIN;
    }

    protected onReelSpinStarted(reelId:number):void {
        super.onReelSpinStarted(reelId);

        EventHandler.dispatchEvent(new GameEvent(FruitsStickyRespinReelStopPresentation.RESET));
        FruitsGameModuleConfig.bonusOverlayView.playAttention(reelId);

    }

    protected onStopSpin(stopData:{ quickStop:boolean, fastSpin:boolean }):void {
        this._quickStop = stopData.quickStop;
        this._fastSpin = stopData.fastSpin;
        const spinStopOffset:number = this.getSpinStopOffset();
        let stopDelay:number = 0;
        let order = this.getStopOrder();
        this._activeOrder = order;

        order.forEach((reel, index) => {
            if(Reels._reels[reel].currentState === ReelAnimationState.IDLE) {
                return;
            }
            (<FruitsReelController>Reels.getReel(reel)).stopIndex = index;
            const stopSpinData:IReelStopSpinData = {
                quickStop : this._quickStop,
                fastSpin : this._fastSpin,
                active : this._activeReels[reel],
                spinStopOffset : spinStopOffset
            };
            stopDelay = Reels._reels[reel].stopSpin(stopSpinData, stopDelay);
        });
    }

    private getStopOrder():number[] {
        if(this._gameMode === FruitsGameMode.BONUS_GAME) {
            if(this._fruitsView.orientation === Orientation.PORTRAIT) {
                return this._orderBonusPort;
            } else {
                return this._orderBonusLand;
            }
        }

        if(this._fruitsView.orientation === Orientation.PORTRAIT) {
            return this._orderPort;
        }

        return this._orderLand;
    }

    private rerunOnChangeTimeline():void {
        if(this._onChangeModeTimeline) {
            if(this._onChangeModeTimeline.isActive()) {
                this._onChangeModeTimeline.pause();
                this._onChangeModeTimeline.kill();
                this._onChangeModeTimeline.clear();

                this._onChangeModeTimeline = new TimelineLite();

                if(this._onChangeModeData.showIntro) {
                    this._onChangeModeTimeline.add(this._fruitsView.getIntroAnimation(true));
                    this._onChangeModeTimeline.add(() => EventHandler.dispatchEvent(new GameEvent(BonusGameIntroView.START_BONUS_INTRO_PRES)));
                }

                this._onChangeModeTimeline.add(this.endChangeMode());
            }
        }
    }

    private onOrientationChange(orientation:Orientation):void {
        let orientationChange = this._orientation !== orientation;

        this._orientation = orientation;
        if(orientationChange) {
            if(this._gameData && this._gameData.nextMode === FruitsGameMode.BONUS_GAME) {
                this.rerunOnChangeTimeline();
            }
        }

        if(this._gameData) {
            this.getNearWinPositions();
        }
    }

    private getNearWinPositions():void {
        if(this._orientation === Orientation.PORTRAIT) {
            FruitsReels.nearWinPositions = (<FruitsParsedGameData>this._gameData).nearWinPositionsPortrait;
            FruitsReels.bigWinExcitementPositions = (<FruitsParsedGameData>this._gameData).bigWinExcitementPositionsPortrait;
        } else {
            FruitsReels.nearWinPositions = (<FruitsParsedGameData>this._gameData).nearWinPositions;
            FruitsReels.bigWinExcitementPositions = (<FruitsParsedGameData>this._gameData).bigWinExcitementPositions;
        }
    }
}